import { OctopusEVLogo } from "@App/Components/atoms/whitelabel/logos/OctopusEVLogo";
import { RepareoLogo } from "@App/Components/atoms/whitelabel/logos/RepareoLogo";
import type { Config } from "@App/configs/interfaces";

/**
 * Configuration for the Octopus Electric Vehicles whitelabel.
 * Extends the default configuration with specific settings for Octopus EV.
 */
export const config: Partial<Config> = {
  slug: "octopusev",
  navbar: {
    logos: {
      left: {
        component: <OctopusEVLogo />,
      },
      right: {
        component: <RepareoLogo />,
      },
    },
    backToPartnerButton: {
      url: "https://octopusev.com/",
    },
  },
  reviews: {
    show: true,
  },
};

export default config;
